import React, { useState } from "react"

import { CrossCompanyPhoneCheck } from "../auth/CrossCompanyPhoneCheck"
import { Button } from "../styled/Button"

const TIDAL_PROMO_CODE = "2022TIDALP1"

export const TidalGetStartedComponent = () => {
  const [submissionPromoCode, setSubmissionPromoCode] = useState(TIDAL_PROMO_CODE)

  const initialValues = {
    phoneNumber: ""
  }

  const getButton = (promoCode) => ({ disabled, handleClick }) => {
    return (
      <>
        <Button
          type="button"
          className="btn"
          primary
          disabled={disabled}
          onClick={() => {
            setSubmissionPromoCode(promoCode)
            handleClick()
          }}
        >
          Continue
        </Button>
      </>)
  }

  const submitButtons = [
    getButton(
        TIDAL_PROMO_CODE
    )
  ]

  return (
    <section>
      <div className="container py-5 hero3">
        <div className="row text-center">
          <div className="col">
            <h3 className="magenta text-center">Let's start your submission</h3>
          </div>
        </div>
        <div className="row text-center">
          <div className="col">
            <p>
            Enter your T-Mobile phone number to begin the redemption process. You will then be prompted to log in to your account.
            </p>
            <img style={{ marginTop: "1rem" }} src={"images/Tidal/tidal_logo.png"} alt="Tidal Logo" className="mb-3" />
            <p>
            Get TIDAL HiFi Plus on us. The ultimate home for music lovers, with over 90 million songs, 450,000+ videos, and access to cool features like lyrics, interactive credits, and the ability to view and share your top streamed artists with friends.
            </p>
            <p>If you are a T-Mobile for Business customer, please click "<a href={process.env.REACT_APP_TMO_TFB_ID_AUTH_URL} rel="noreferrer">Here</a>".</p>
            <br></br>
          </div>
        </div>
        <div className="row text-center">
          <div className="col" style={{ marginBottom: "6px" }}>
            <b>Start by entering your phone number</b>
          </div>
        </div>
        <div className="mx-auto col">
          <CrossCompanyPhoneCheck initialValues={initialValues} buttons={submitButtons} promoCode={submissionPromoCode} phoneInputClass="col-md-4 mx-auto" />
        </div>
        <div className="mx-auto col-md-4">
          <p>
            Questions before you continue?
            Find answers <a href="https://www.t-mobile.com/content/t-mobile/consumer/isp/FAQ.html" target="_blank" rel="noopener noreferrer">here</a>.
          </p>
        </div>
      </div>
    </section>
  )
}
